export const UPLOAD_ERROR_TITLE = 'Background upload failed';
export const UPLOAD_ERROR_DESCRIPTION =
  'Supported file types: jpg, jpeg, png, gif (5 MB limit). Maximum dimensions: 1920 x 1080 pixels';
export const UPLOAD_SUCCESS_TITLE = 'Background upload success';
